import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'

import { Gender } from 'common-constants/api6.types'

interface TitleProps {
  gender: string | null
  name: string
}

export const Title: FC<TitleProps> = ({ gender, name }) => {
  if (gender === Gender.Male) {
    return (
      <FormattedMessage
        id="greeting.last_photo.MALE"
        defaultMessage="Понравился {name}?"
        values={{ name }}
      />
    )
  } else {
    return (
      <FormattedMessage
        id="greeting.last_photo.FEMALE"
        defaultMessage="Понравилась {name}?"
        values={{ name }}
      />
    )
  }
}
